import {
	AcademicCap,
	AdjustmentsHorizontal,
	ArrowDown,
	ArrowDownTray,
	ArrowLongDown,
	ArrowLongLeft,
	ArrowLongRight,
	ArrowLongUp,
	ArrowPath,
	ArrowPathRoundedSquare,
	ArrowRight,
	ArrowRightOnRectangle,
	ArrowTopRightOnSquare,
	ArrowUp,
	ArrowUpCircle,
	ArrowUpTray,
	ArrowUturnLeft,
	ArrowsPointingIn,
	ArrowsPointingOut,
	ArrowsRightLeft,
	ArrowsUpDown,
	Banknotes,
	Bars3,
	Bars3BottomRight,
	Bars4,
	Bell,
	Bolt,
	BookOpen,
	Bookmark,
	BookmarkSlash,
	BugAnt,
	BuildingOffice,
	BuildingStorefront,
	Calendar,
	ChartBar,
	ChartPie,
	ChatBubbleLeftRight,
	Check,
	CheckBadge,
	CheckCircle,
	ChevronDoubleDown,
	ChevronDoubleLeft,
	ChevronDoubleRight,
	ChevronDoubleUp,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUpDown,
	CircleStack,
	ClipboardDocument,
	ClipboardDocumentCheck,
	ClipboardDocumentList,
	Clock,
	CodeBracket,
	Cog6Tooth,
	ComputerDesktop,
	CreditCard,
	CurrencyDollar,
	CurrencyEuro,
	CurrencyPound,
	CurrencyYen,
	CursorArrowRays,
	DevicePhoneMobile,
	DeviceTablet,
	Document,
	DocumentArrowUp,
	DocumentCheck,
	DocumentDuplicate,
	DocumentMinus,
	DocumentText,
	EllipsisVertical,
	Envelope,
	EnvelopeOpen,
	ExclamationCircle,
	ExclamationTriangle,
	Eye,
	EyeSlash,
	FingerPrint,
	Folder,
	Funnel,
	GlobeAlt,
	GlobeEuropeAfrica,
	Home,
	Identification,
	InformationCircle,
	Key,
	LightBulb,
	Link,
	LockClosed,
	LockOpen,
	MagnifyingGlass,
	MapPin,
	Megaphone,
	MinusCircle,
	Moon,
	NoSymbol,
	PaintBrush,
	PaperAirplane,
	PauseCircle,
	Pencil,
	PencilSquare,
	Phone,
	PlayCircle,
	Plus,
	PlusCircle,
	Power,
	PuzzlePiece,
	QrCode,
	QuestionMarkCircle,
	QueueList,
	RocketLaunch,
	Share,
	ShieldCheck,
	ShieldExclamation,
	ShoppingBag,
	Sparkles,
	Squares2x2,
	Star,
	Sun,
	Tag,
	Ticket,
	Trash,
	User,
	UserCircle,
	UserGroup,
	UserMinus,
	UserPlus,
	Users,
	VideoCamera,
	ViewColumns,
	Window,
	Wrench,
	XCircle,
	XMark,
} from '@steeze-ui/heroicons'

export const Icons = {
	BuildingStorefront,
	QueueList,
	Power,
	ChevronDoubleDown,
	PencilSquare,
	UserMinus,
	ShoppingBag,
	Megaphone,
	AcademicCap,
	ClipboardDocumentList,
	Folder,
	PaintBrush,
	BuildingOffice,
	Home,
	AdjustmentsHorizontal,
	BugAnt,
	ArrowDown,
	ArrowDownTray,
	ArrowLongDown,
	ArrowLongLeft,
	ArrowLongRight,
	ArrowLongUp,
	ArrowPath,
	ArrowPathRoundedSquare,
	ArrowRight,
	ArrowRightOnRectangle,
	ArrowsPointingIn,
	ArrowsPointingOut,
	ArrowsRightLeft,
	ArrowTopRightOnSquare,
	ArrowUp,
	ArrowsUpDown,
	ArrowUpCircle,
	ArrowUpTray,
	ArrowUturnLeft,
	Banknotes,
	Bars3BottomRight,
	Bars3,
	Bars4,
	Bell,
	Bolt,
	Bookmark,
	BookmarkSlash,
	BookOpen,
	Calendar,
	ChartBar,
	ChartPie,
	Window,
	ChatBubbleLeftRight,
	Check,
	CheckBadge,
	CheckCircle,
	ChevronDoubleLeft,
	ChevronDoubleRight,
	ChevronDoubleUp,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUpDown,
	CircleStack,
	ClipboardDocument,
	ClipboardDocumentCheck,
	Clock,
	CodeBracket,
	Cog6Tooth,
	ComputerDesktop,
	CreditCard,
	CurrencyDollar,
	CurrencyEuro,
	CurrencyPound,
	CurrencyYen,
	CursorArrowRays,
	DevicePhoneMobile,
	DeviceTablet,
	Document,
	DocumentArrowUp,
	DocumentCheck,
	DocumentMinus,
	DocumentDuplicate,
	DocumentText,
	EllipsisVertical,
	Envelope,
	EnvelopeOpen,
	ExclamationCircle,
	ExclamationTriangle,
	Eye,
	EyeSlash,
	FingerPrint,
	Funnel,
	GlobeAlt,
	GlobeEuropeAfrica,
	Identification,
	InformationCircle,
	Key,
	LightBulb,
	Link,
	LockClosed,
	LockOpen,
	MagnifyingGlass,
	MapPin,
	MinusCircle,
	Moon,
	NoSymbol,
	PaperAirplane,
	PauseCircle,
	Pencil,
	Phone,
	PlayCircle,
	Plus,
	PlusCircle,
	PuzzlePiece,
	QrCode,
	QuestionMarkCircle,
	RocketLaunch,
	Share,
	ShieldCheck,
	ShieldExclamation,
	Sparkles,
	Squares2x2,
	Star,
	Sun,
	Tag,
	Ticket,
	Trash,
	User,
	UserCircle,
	UserGroup,
	UserPlus,
	Users,
	VideoCamera,
	ViewColumns,
	Wrench,
	XCircle,
	XMark,
}
